import React from 'react';
import NavigationItem from '../NavigationItem/NavigationItem';
import Aux from '../../../hoc/Auxiliary/Auxiliary';
import { withRouter } from 'react-router-dom';
import classes from './NavigationItems.module.css';
import { FontAwesomeIcon  } from '@fortawesome/react-fontawesome';
// import aboutImage from '../../../assets/images/aboutUs.png';

const navigationItems = (props) => {
    // console.log('props in NAV', props)
    let attachClasses = [classes.NavigationItems];
    let sideDrawer = false; //OR null?????

    // if (props.location.pathname === '/') {
    //     attachClasses = [classes.NavigationItems, classes.HomePage];
    // }

    if (props.sideDrawer) {
        attachClasses = [classes.NavigationItems, classes.SideDrawerLinks];
        sideDrawer = true;
    }

    if (props.footer) {
        attachClasses = [classes.NavigationItems, classes.FooterLinks];
    }

    return (
        <Aux>
            <ul className={attachClasses.join(' ')}>
                { props.footer
                    ? <>
                    {/* <NavigationItem footer link="/recipes">Всички рецепти</NavigationItem> */}
                        <NavigationItem footer link="/about"><p>За нас</p></NavigationItem>
                        <NavigationItem footer link="/cookies">Бисквитки</NavigationItem>
                        <NavigationItem footer link="/sladko-ili-soleno">Сладко или Солено</NavigationItem>
                        <NavigationItem footer link="/gdpr">Политика на поверителност</NavigationItem></>
                    : <><NavigationItem link="/" exact>
                            <FontAwesomeIcon className={classes.FaIcon} icon="puzzle-piece" />
                            <p>Най-нови</p>
                        </NavigationItem>
                        <NavigationItem link="/recipes/sweet">
                            <FontAwesomeIcon className={classes.FaIcon} icon="candy-cane" />
                            <p>Сладко</p>
                        </NavigationItem>
                        <NavigationItem link="/recipes/salted">
                            <FontAwesomeIcon className={classes.FaIcon} icon="hamburger" />
                            <p>Солено</p>
                        </NavigationItem>
                        <NavigationItem alignLeft link="/recipes/children">
                            <FontAwesomeIcon className={classes.FaIcon} icon="hand-holding-heart" />
                            <p>За децата</p>
                        </NavigationItem>
                        <NavigationItem link="/gardening">
                            <FontAwesomeIcon className={classes.FaIcon} icon="seedling" />
                            <p>За градината</p>
                        </NavigationItem></>
                }
            </ul>
        </Aux>
    )
};

export default withRouter(navigationItems);